/* istanbul ignore file */
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { INIT_STATE as RNR_INIT_STATE, ratingsAndReviewsSlice } from './ratingsAndReviews';

const INIT_STATE = Object.freeze({
  acquired: undefined,
  trialAppAcquired: false,
  assetVersion: '',
  ccCategories: null,
  isUserPartOfOrg: false,
  hasEntitlementInfo: false,
  hasTrialEntitlementInfo: false,
  detailScreen: null,
  detailScreenLoading: true,
});

const store = (set, get) => ({
  ...INIT_STATE,
  ...ratingsAndReviewsSlice(set, get),
});

export const FULL_INIT_STATE = {
  ...INIT_STATE,
  ...RNR_INIT_STATE,
};

export const useStore = create(devtools(store));
